import { IndicatorInput, IndicatorInput_InputType } from '../proto/generated/indicator'

const parseQuotedString = (body: string, key: string): string | undefined => {
    const match = body.match(new RegExp(`${key}:\\s*"([^"]*)"`))
    return match?.[1]
}

const parseStringOptions = (body: string): string[] => {
    const match = body.match(/options:\s*\[([\s\S]*?)\]/)
    if (!match?.[1]) return []
    return [...match[1].matchAll(/"([^"]*)"/g)].map((item) => item[1])
}

const parseGroup = (body: string): string => {
    const quoted = parseQuotedString(body, 'group')
    if (quoted) return quoted
    const ident = body.match(/group:\s*([A-Za-z_][\w]*)/)?.[1]
    return ident ?? ''
}

const mapInputType = (type: 'string' | 'int' | 'float' | 'bool'): IndicatorInput_InputType => {
    switch (type) {
        case 'int':
            return IndicatorInput_InputType.INTEGER
        case 'float':
            return IndicatorInput_InputType.FLOAT
        case 'bool':
            return IndicatorInput_InputType.BOOLEAN
        default:
            return IndicatorInput_InputType.STRING
    }
}

const parseInputCalls = (script: string, type: 'string' | 'int' | 'float' | 'bool'): IndicatorInput[] => {
    const regex = new RegExp(`input\\.${type}\\(\\{([\\s\\S]*?)\\}\\)`, 'g')
    const inputs: IndicatorInput[] = []
    for (const match of script.matchAll(regex)) {
        const body = match[1]
        const title = parseQuotedString(body, 'title')
        if (!title) continue
        const code = parseQuotedString(body, 'code') ?? title.replace(/\W/g, '_').toUpperCase()
        inputs.push({
            title,
            code,
            type: mapInputType(type),
            defval: parseQuotedString(body, 'defval') ?? '',
            minval: parseQuotedString(body, 'minval') ?? '',
            maxval: parseQuotedString(body, 'maxval') ?? '',
            options: type === 'string' ? parseStringOptions(body) : [],
            group: parseGroup(body),
            tooltip: parseQuotedString(body, 'tooltip') ?? '',
            display: true,
        })
    }
    return inputs
}

/** Parse indicator input definitions from a Sirius indicator script (backend source). */
export function parseIndicatorInputsFromScript(script?: string): IndicatorInput[] {
    if (!script?.trim()) return []
    return [
        ...parseInputCalls(script, 'string'),
        ...parseInputCalls(script, 'int'),
        ...parseInputCalls(script, 'float'),
        ...parseInputCalls(script, 'bool'),
    ]
}
